import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_AboutSection = _resolveComponent("AboutSection")!
  const _component_ContentSection = _resolveComponent("ContentSection")!
  const _component_RecentVideosSection = _resolveComponent("RecentVideosSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      headers: _ctx.pageData.headers
    }, null, 8, ["headers"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData.sections, (section, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (section.type === 'about')
          ? (_openBlock(), _createBlock(_component_AboutSection, {
              key: 0,
              heading: section.heading,
              content: section.content,
              showHeading: section.showHeading
            }, null, 8, ["heading", "content", "showHeading"]))
          : (section.type === 'content')
            ? (_openBlock(), _createBlock(_component_ContentSection, {
                key: 1,
                heading: section.heading,
                content: section.content,
                showHeading: section.showHeading,
                sectionStyle: section.style
              }, null, 8, ["heading", "content", "showHeading", "sectionStyle"]))
            : (section.type === 'recent_videos')
              ? (_openBlock(), _createBlock(_component_RecentVideosSection, {
                  key: 2,
                  count: section.config?.count || 3
                }, null, 8, ["count"]))
              : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}